'use client';

import { useEffect, useState } from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import ClientLogin from './ClientLogin';
import { createClient } from '@/lib/supabase/browser';

export default function LoginWithNotice() {
  const params = useSearchParams();
  const router = useRouter();
  const verifyEmail = params.get('verifyEmail');
  const [signupEmail, setSignupEmail] = useState<string | null>(null);
  const [resending, setResending] = useState(false);
  const [resentMsg, setResentMsg] = useState<string | null>(null);

  useEffect(() => {
    try {
      const e = sessionStorage.getItem('lastSignupEmail');
      if (e) setSignupEmail(e);
    } catch {}
  }, []);

  const resend = async () => {
    if (!signupEmail) return;
    setResending(true);
    setResentMsg(null);
    try {
      // Build from the canonical site URL (never window.location.origin) and
      // land on the server callback route (token_hash flow). The post-verify
      // destination is forwarded via the ?redirect= param /auth/callback honors.
      const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://www.indiestryvoice.com';
      const redirectTo = `${siteUrl}/auth/callback?redirect=${encodeURIComponent('/onboarding/step/1')}`;
      const supabase = createClient();
      const { error } = await supabase.auth.resend({ type: 'signup', email: signupEmail, options: { emailRedirectTo: redirectTo } });
      if (error) throw error;
      setResentMsg('Verification email sent again.');
    } catch (e: any) {
      setResentMsg(e?.message || 'Failed to resend');
    } finally {
      setResending(false);
    }
  };

  if (verifyEmail) {
    return (
      <main className="min-h-screen bg-surface-0 text-text-primary flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-surface-2 border border-border-subtle rounded-2xl p-6 text-center">
          <h1 className="text-2xl font-semibold mb-2">Confirm your email</h1>
          <p className="text-text-secondary mb-4">We sent a verification link{signupEmail ? ` to ${signupEmail}` : ''}. Click the link in your inbox to finish creating your account.</p>
          <div className="flex items-center justify-center gap-3 mt-2">
            <button onClick={resend} disabled={resending || !signupEmail} className="px-4 py-2 rounded-lg bg-accent text-text-on-accent disabled:opacity-50">{resending ? 'Resending…' : 'Resend email'}</button>
            <button onClick={() => router.push('/')} className="px-4 py-2 rounded-lg bg-surface-3 text-text-primary">Back to home</button>
          </div>
          {resentMsg && <p className="text-xs mt-3 text-text-tertiary">{resentMsg}</p>}
        </div>
      </main>
    );
  }

  return <ClientLogin />;
} 